import SFAuthService from '../../services/sfAuth/SFAuthService'

export const SET_USER_DATA = 'USER_SET_DATA'
export const REMOVE_USER_DATA = 'USER_REMOVE_DATA'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const USER_NOT_MU_AUTHENTICATED = 'USER_NOT_MU_AUTHENTICATED'

export function setUserData (user) {
  console.log('set user Data', user)
  return dispatch => {
    dispatch({
      type: SET_USER_DATA,
      data: user
    })
  }
}

export function userNotAutenticatedForMultiuser () {
  return dispatch => {
    dispatch({
      type: USER_NOT_MU_AUTHENTICATED
    })
  }
}

export function logoutUser () {
  return (dispatch, user) => {
    const conn = SFAuthService.getConnection()

    const handleLogout = () => {
      SFAuthService.logout().then(res => {
        console.log('logged out', res)
        console.log('conn', conn)
        dispatch({
          type: USER_LOGGED_OUT
        })
        console.log('redirect after logout')
        window.location = '/'
      })
    }

    conn
      .requestPost('/services/apexrest/community/hardLogout', {
        userId: user.userId
      }).then(result => {
        handleLogout()
      }, reject => {
        console.error('Apex logout error', reject)
        handleLogout()
      })
  }
}
